export default __webpack_public_path__ + "static/media/arrowupgreen.50835842.svg";